import { gql } from "@apollo/client";

export const createLeaderboardMutation = gql`
  mutation CreateLeaderboard($LeaderboardsInput: LeaderboardsInput!) {
    createLeaderboard(input: $LeaderboardsInput) {
      id
      programId
      title
      startsAt
      endsAt
      rankOrder
      tieBreaker
      activePointMinimum
      minParticipationCount
      awardApproval
      createdAt
    }
  }
`;

export const updateLeaderboardMutation = gql`
  mutation UpdateLeaderboard(
    $id: ID!
    $LeaderboardsUpdateInput: LeaderboardsUpdateInput!
  ) {
    updateLeaderboard(id: $id, input: $LeaderboardsUpdateInput) {
      id
      programId
      title
      startsAt
      endsAt
      rankOrder
      tieBreaker
      activePointMinimum
      minParticipationCount
      awardApproval
      createdAt
    }
  }
`;

export const deleteLeaderboardMutation = gql`
  mutation DeleteLeaderboard($id: ID!) {
    deleteLeaderboard(id: $id)
  }
`;

export const archiveLeaderboardMutation = gql`
  mutation ArchiveLeaderboard($id: ID!) {
    archiveLeaderboard(id: $id) {
      id
      programId
      title
      startsAt
      endsAt
      rankOrder
      tieBreaker
      activePointMinimum
      minParticipationCount
      awardApproval
      metadata
      createdAt
    }
  }
`;
export const approveLeaderboardMutation = gql`
  mutation ApproveLeaderboard($id: ID!) {
    approveLeaderboard(id: $id) {
      id
      programId
      title
      startsAt
      endsAt
      rankOrder
      tieBreaker
      activePointMinimum
      minParticipationCount
      awardApproval
      metadata
      createdAt
    }
  }
`;

export const resetLeaderboardRewardRanks = gql`
  mutation resetLeaderboardRewardRanks($id: ID!) {
    resetLeaderboardRewardRanks(id: $id) {
      updatedAt
    }
  }
`;

export const recalculateLeaderboardRankings = gql`
  mutation RecalculateLeaderboardRankings($lbId: ID!) {
    recalculateLeaderboardRankings(lbId: $lbId)
  }
`;
